// extracted by mini-css-extract-plugin
export var container = "embed-social-media-v2-module--container--3cad9";
export var embedGrid = "embed-social-media-v2-module--embedGrid--7d860";
export var embedItem = "embed-social-media-v2-module--embedItem--3faae";
export var fallbackLink = "embed-social-media-v2-module--fallbackLink--0e262";
export var linkedin = "embed-social-media-v2-module--linkedin--ed3e1";
export var linkedinWrapper = "embed-social-media-v2-module--linkedinWrapper--60e69";
export var twitter = "embed-social-media-v2-module--twitter--dd586";